export const SORT_ORDER = { id: 'streetAddress' };
